/**
 * AssetScreenerUserEvents
 * Registry of events for the Asset Screener pages
 */
export enum AssetScreenerUserEvents {
    AssetCardClickVisitProduct = "Asset Screener - Asset Card - Click Visit Product",
    AssetCardClickViewAnalytics = "Asset Screener - Asset Card - Click View Analytics",
    AssetCardClickAssetClass = "Asset Screener - Asset Card - Click Asset Class",
    AssetCardClickNetwork = "Asset Screener - Asset Card - Click Network",
    FilterSearch = "Asset Screener - Filter - Search",
    FilterMinInvestment = "Asset Screener - Filter - Min Investment",
    FilterYieldRange = "Asset Screener - Filter - Yield Range",
    FilterMinAUM = "Asset Screener - Filter - Min AUM",
    FilterRedemption = "Asset Screener - Filter - Redemption",
    FilterNetwork = "Asset Screener - Filter - Network",
    FilterNonKyc = "Asset Screener - Filter - Non-KYC",
    FilterAssetClass = "Asset Screener - Filter - Asset Class",
    FilterSortBy = "Asset Screener - Filter - Sort By",
    FilterClearAll = "Asset Screener - Filter - Clear All",
    AssetCardClickLoginRequired = "Asset Screener - Click Login Required",
    AssetCardSubmitDataRoomAccess = "Asset Screener - Asset Card - Submit Data Room Access",
    AssetCardClickBookMeeting = "Asset Screener - Asset Card - Click Book Meeting",
    AssetRowExpand = "Asset Screener - Asset Row - Expand",
    AssetRowCollapse = "Asset Screener - Asset Row - Collapse",
    PerformanceChartChangeTab = "Asset Screener - Performance Chart - Change Tab",
}
